import { configureStore } from "@reduxjs/toolkit";

import uiDetailsConsoleMenuSlice from "./Redux/UIMenus/uiDetailsConsoleMenuSlice";
import uiMenuStatesSlice from "./Redux/UIMenus/uiMenuStatesSlice";
import uiMainMenuSlice from "./Redux/UIMenus/uiMainMenuSlice";
import uiPedanaMenuSlice from "./Redux/UIMenus/uiPedanaMenuSlice";
import uiParaventiMenuSlice from "./Redux/UIMenus/uiParaventiMenuSlice";
import uiOmbrelloniMenuSlice from "./Redux/UIMenus/uiOmbrelloniMenuSlice";
import uiLateraleCristalMenuSlice from "./Redux/UIMenus/uiLateraleCristalMenuSlice";
import uiExportMenuSlice from "./Redux/UIMenus/uiExportMenuSlice";
import uiCalcoloMenuSlice from "./Redux/UIMenus/uiCalcoloMenuSlice";

export default configureStore({
    reducer: {        
        uiMenuState: uiMenuStatesSlice,
        uiMainMenu: uiMainMenuSlice,
        uiPedanaMenu: uiPedanaMenuSlice,
        uiParaventiMenu: uiParaventiMenuSlice,
        uiOmbrelloniMenu: uiOmbrelloniMenuSlice,
        uiCristalMenu: uiLateraleCristalMenuSlice,
        uiConsoleMenu: uiDetailsConsoleMenuSlice,
        uiExportMenu: uiExportMenuSlice,
        uiCalcoloMenu: uiCalcoloMenuSlice,
    }
});